<span class="mapper" [class.highlight]="shouldHighlight" (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()">{{mapper}}<span>
